import CLASS_NAMES from "@js/constants/css-constants.es6.js";
import {ATTRIBUTES} from "@js/constants/html-constants.es6.js";
import ContentUtils from "@js/utils/content-utils.es6.js";
import Element from "@js/core/element.es6.js";
export default class Paragraph extends Element {
  get viewMode() {
    const classList = this.$()
      .attr(ATTRIBUTES.CLASS)
      .split(' ');
    const viewModeClass = classList.filter(className =>
      className.includes(CLASS_NAMES.PARAGRAPH_VIEW_MODE_PREFIX),
    )[0];
    if (viewModeClass) {
      return viewModeClass
        .split(CLASS_NAMES.PARAGRAPH_VIEW_MODE_PREFIX)[1]
        .replaceAll('-', '_');
    }

    return null;
  }

  constructor({ machineName, parentElement }) {
    const className = ContentUtils.paragraphMachineNameToClassName(machineName);
    const selector = `.${className}`;

    super({ parentElement, selector, inclusive: true });
  }
}
